import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { Spinner } from '../components/Spinner';

const Home = lazy(() => import('../pages/Home'));
const ViewDocument = lazy(() => import('../pages/ViewDocument'));
const NotFound = lazy(() => import('../pages/NotFound'));

function TokenRedirect({ prefix }: { prefix: string }) {
  const { token } = useParams<{ token: string }>();
  return <Navigate to={`/${prefix}/${token}`} replace />;
}

function PageLoader() {
  return (
    <div className="flex min-h-[40vh] items-center justify-center text-brand-600">
      <Spinner size={28} />
    </div>
  );
}

export default function App() {
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1">
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            {/* Shared document links */}
            <Route path="/q/:token" element={<ViewDocument docType="quotation" />} />
            <Route path="/i/:token" element={<ViewDocument docType="invoice" />} />
            {/* Legacy share-path aliases */}
            <Route path="/quotations/:token" element={<TokenRedirect prefix="q" />} />
            <Route path="/invoices/:token" element={<TokenRedirect prefix="i" />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
